import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Typography, Button, Tooltip } from "@material-ui/core";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";

// Components
import MaturityBanner from "./MaturityBanner";

// Styles
import DashboardCategoryResultPopoverStyle from "../../../../assets/styles/materialUI/questionnaire/assessmentResult/assessmentDashboard/DashboardCategoryResultPopoverStyle";

// Providers
import { useLanguage } from "../../../../contexts/languageContext";

export default function DashboardCategoryResultPopover({
	score,
	subCategory,
	openTooltip,
	setOpenTooltip,
	barLength,
	color,
	catIndex,
	subIndex,
	float,
}) {
	const classes = DashboardCategoryResultPopoverStyle({ color, barLength, float });
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const maturityLevels = [
		{ label: t("maturity.levels.notStarted"), color: "red" },
		{ label: t("maturity.levels.developing"), color: "yellow" },
		{ label: t("maturity.levels.established"), color: "orange" },
		{ label: t("maturity.levels.integrated"), color: "lightgreen" },
		{ label: t("maturity.levels.advanced"), color: "darkgreen" },
	];

	return (
		<Tooltip
			title={
				<Grid className={classes.popoverContainer} dir={direction}>
					<Typography className={classes.popoverHeader} variant="subtitle2">
						{t("assessment.dashboard.factor")}:{" "}
						<b>{direction === "ltr" ? subCategory.title : subCategory.title_ar}</b>
						<br />
						{t("assessment.dashboard.factorLevel")}: <b>{score.toFixed(2)} / 10</b>
					</Typography>
					<Grid className={classes.maturityLevelContainer}>
						{maturityLevels.map(({ label, color }) => (
							<Grid className={classes.maturityLevelSubContainer} key={label}>
								<Typography
									className={classes.maturityLevelBanner}
									style={{ backgroundColor: color }}
								/>
								<Typography className={classes.maturityLevelText}>{label}</Typography>
							</Grid>
						))}
					</Grid>
					<Grid className={classes.tableWrapper}>
						<Table className={classes.table} size="small">
							<TableHead>
								<TableRow>
									<TableCell className={classes.tableHeaderCell}>
										{t("assessment.dashboard.evaluationMetrics")}
									</TableCell>
									<TableCell className={classes.tableHeaderCell}>
										{t("assessment.dashboard.response")}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{subCategory.questions.map((q, index) => (
									<TableRow key={q.id}>
										<TableCell className={classes.questionCell}>
											<Typography className={classes.typography}>{index + 1}.</Typography>
											{direction === "ltr" ? q.question : q.question_ar}
										</TableCell>
										<TableCell className={classes.scoreCell}>
											<MaturityBanner score={q.score} />
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Grid>
					<Button
						onClick={() => setOpenTooltip(null)}
						className={classes.button}
						variant="contained"
						color="primary"
					>
						{t("common.buttons.close")}
					</Button>
				</Grid>
			}
			interactive
			open={openTooltip === `${catIndex}-${subIndex}1`}
			disableFocusListener
			disableHoverListener
			disableTouchListener
			classes={{
				tooltip: classes.tooltip,
				popper: classes.centeredPopper,
			}}
			PopperProps={{
				modifiers: {
					flip: {
						enabled: false,
					},
					preventOverflow: {
						enabled: false,
					},
					hide: {
						enabled: false,
					},
				},
			}}
		>
			<Grid
				tabIndex={0}
				onClick={(e) => {
					e.stopPropagation();
					setOpenTooltip((prev) => (prev === `${catIndex}-${subIndex}1` ? null : `${catIndex}-${subIndex}1`));
				}}
				className={classes.progressBar}
			/>
		</Tooltip>
	);
}
